import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { PageHeader, Form, Input, Button, Switch, Cascader, Typography, Spin, message } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';

import * as ToolRequest from '../../tools/ToolRequest';
import * as ToolPermission from '../../tools/ToolPermission';

import SpinFull from '../../components/SpinFull';

const formLayout = {
  labelCol: {
    sm: { span: 5 },
  },
  wrapperCol: {
    sm: { span: 16 },
  },
  labelWrap: true,
};

const formTailLayout = {
  wrapperCol: {
    sm: { offset: 5, span: 16 },
  },
};

const { Title } = Typography;
const { TextArea } = Input;

export default function FarmSiteAddScreen(props) {
  const history = useHistory();
  const userData = useSelector(state => state.user);
  const userPermissionsData = useSelector(state => state.userPermissions);

  const isAllowedCrossCompany = ToolPermission.hasPermission(userPermissionsData, 'ui:company', 'get:xc');

  const [loaded, setLoaded] = useState(false);
  const [loading, setLoading] = useState(false);
  const [companyOptions, setCompanyOptions] = useState([]);

  const { metadata } = props;

  useEffect(() => {
    (async () => {
      const companyRes = isAllowedCrossCompany ? (await ToolRequest.request('GET', '/v1/company', {
        count: 1000,
      })) : {
        data: [await ToolRequest.request('GET', `/v1/company/${userData.companyId}`)],
      };

      setCompanyOptions(companyRes.data.map(company => ({
        value: company.id,
        label: `${company.displayName} (${company.name})`,
      })));

      setLoaded(true);
    })();
  }, []);

  const onFinish = async (values) => {
    setLoading(true);

    try {
      const res = await ToolRequest.request('POST', '/v1/farm-site', {
        companyId: values.companyId[0],
        name: values.name,
        address: values.address,
      });

      message.success('Create Site successfully');

      history.push('/farm-site');
    } catch (err) {
      setLoading(false);

      if (err?.response?.data) {
        switch (err.response.data) {
          default:
            return message.error('Unknown errors. Please retry');
        }
      }

      message.error('Unknown error. Please retry');
    }
  };

  return loaded ? (
    <PageHeader
      title="Add a Site"
      onBack={() => history.push('/farm-site')}
    >
      <Spin spinning={loading}>
        <Form
          {...formLayout}
          initialValues={{
            companyId: isAllowedCrossCompany ? [] : [companyOptions[0].value],
          }}
          onFinish={onFinish}
        >
          <Form.Item
            label="Company"
            name="companyId"
            rules={[
              {
                required: isAllowedCrossCompany,
                message: 'Please select a company',
              },
            ]}
          >
            <Cascader
              options={companyOptions}
              disabled={!isAllowedCrossCompany}
            />
          </Form.Item>

          <Form.Item
            label="Name"
            name="name"
            rules={[
              {
                required: true,
                message: 'Please enter the name',
              },
            ]}
          >
            <Input
              placeholder="Name"
            />
          </Form.Item>

          <Form.Item
            label="Address"
            name="address"
          >
            <Input.TextArea
              placeholder="Address"
            />
          </Form.Item>

          <Form.Item {...formTailLayout}>
            <Button type="primary" htmlType="submit" block>
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Spin>
    </PageHeader>
  ) : <SpinFull />;
};
